export interface HeaderData {
    heading: string;
    title: string;
    content: string;
    backgroundImage?: string;
    template?: string;
    video?: {
        url: string;
        thumbnail: string;
        slug: string;
    }
}

export interface SectionData {
    type: string;
    heading: string;
    content: string;
    showHeading: boolean;
    style?: string;
    config?: {
        count?: number;
    }
}

export interface PageData {
    headers: HeaderData[];
    sections: SectionData[];
}

import pagesData from '@/data/pages.json';

const pages: Record<string, PageData> = pagesData;

class PageService {
    getPage(page_key: string): PageData {
        const page = pages[page_key];
        return page;
    }
}

export default new PageService();
